// Golf 5 (English): consent for a child under 16 (own login, photo) and the privacy statement
// page. Same shape as golf5App.nl.ts; the consent texts count towards CHILD_CONSENT_TEXT_HASHES.
export const appChildConsentEn = {
    version: '2026-09-26.1',
    title: 'Consent for {name}',
    intro: '{name} is under 16. Before {name} gets an own login or a photo, we first ask a parent for consent.',
    notNeeded: '{name} is 16 or older and decides about an own login and a photo.',
    login: {
        title: 'Own login',
        text: 'With an own login, {name} can sign in to the app on a phone or computer. {name} then sees the family’s own calendar, tasks, points and messages, but never consents, email addresses or health. AMUMIN B.V. keeps who gave consent, when, and which text you read. You can withdraw at any time: the login stops working straight away.',
        check: 'I am a parent or guardian of {name} and I consent to an own login.',
    },
    photo: {
        title: 'Photo as avatar',
        text: 'With consent you can use a photo of {name} instead of an icon. The photo is then shown in the app and on the board on the wall: everyone in the room with the tablet sees it. We remove the location and other data from the photo and share it with no one. AMUMIN B.V. keeps who gave consent, when, and which text you read. You can withdraw at any time: the photo is removed straight away.',
        check: 'I am a parent or guardian of {name} and I consent to a photo.',
    },
    ask: 'Give consent',
    give: 'Give consent',
    cancel: 'Not now',
    withdraw: 'Withdraw',
    withdrawConfirm: 'Yes, withdraw',
    withdrawLogin: 'Withdraw consent for the own login? {name}’s login stops working straight away.',
    withdrawPhoto: 'Withdraw consent for the photo? {name}’s photo is removed straight away.',
    none: 'No consent yet',
    givenBy: 'Consent from {name} on {date}',
    givenByYou: 'Your consent on {date}',
    givenOn: 'Consent on {date}',
    hasLogin: '{name} now has an own login.',
    hasPhoto: '{name} now has a photo.',
    given: 'Consent given',
    withdrawn: 'Consent withdrawn',
    withdrawnLogin: '{name}’s login no longer works.',
    withdrawnPhoto: '{name}’s photo has been removed.',
    checkRequired: 'Tick the box first.',
    privacyLink: 'More in the privacy statement',
    /** Review g5 sec r2: een kindlogin van vóór 0044 zonder toestemming. */
    loginWithoutConsent: '{name} already has a login without consent: give consent or turn the login off.',
    disableLogin: 'Turn login off',
    disableLoginAsk: 'Turn {name}’s login off? It stops working straight away.',
    disableLoginConfirm: 'Yes, turn off',
    loginDisabled: '{name}’s login is off.',
    /** Gezin: de lijst met zulke kinderen (namen eronder). */
    missingList: 'These children already have a login without consent: give consent or turn the login off.',
    gateLogin: 'This person has an own login. A child under 16 first needs consent from a parent: remove the login first, then change the age and give consent after that.',
    gatePhoto: 'A photo of a child under 16 needs consent from a parent. Give consent first or remove the photo.',
};
export const appPrivacyStatementEn = {
    title: 'Privacy statement',
    back: 'Back to the app',
    concept: 'Draft, being reviewed by a lawyer',
    version: 'Version {version} · {date}',
    contents: 'Contents',
    onlyDutch: 'This privacy statement is not yet available in your language. Below is the Dutch text; you can also choose English.',
    showDutch: 'Nederlands',
    showEnglish: 'English',
    placeholder: 'to be completed',
};
//# sourceMappingURL=golf5App.en.js.map